// services/useFetchClientByCnpjCpf.ts
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import api from '@/lib/api'

type Client = any // tipar seu Client aqui

export function useFetchClientByCnpjCpfTime(
  cnpjcpf?: string,
  options?: Omit<UseQueryOptions<Client | null, unknown, Client | null, any[]>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: ['client-by-cnpj', cnpjcpf],
    enabled: !!cnpjcpf && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (!cnpjcpf) return null
      const { data } = await api.get(`/clients/${cnpjcpf}`)
      // Normalize: sucesso sem corpo => null
      return data?.data ?? null
    },
    ...options
  })
}
